import { Injectable, NgZone } from "@angular/core";
import { SwUpdate } from "@angular/service-worker";
import { Subscription, interval } from "rxjs";

@Injectable({ providedIn: "root" })
export class NewVersionCheckerService {
  isNewVersionAvailable: boolean = false;
  // intervalSource = interval(1 * 60 * 1000); // 1 minute
  // intervalSource = interval(10000);
  // intervalSubscription: Subscription;

  constructor(
    private swUpdate: SwUpdate,
    private zone: NgZone,
  ) {
    console.info("NewVersionCheckerService loaded");
    this.checkForUpdate();

    this.swUpdate.versionUpdates.subscribe((evt) => {
      switch (evt.type) {
        case "VERSION_DETECTED":
          console.info(`Downloading new app version: ${evt.version.hash}`);
          break;
        case "VERSION_READY":
          console.info(`Current app version: ${evt.currentVersion.hash}`);
          console.info(
            `New app version ready for use: ${evt.latestVersion.hash}`,
          );
          this.isNewVersionAvailable = true;
          break;
        case "VERSION_INSTALLATION_FAILED":
          console.info(
            `Failed to install app version '${evt.version.hash}': ${evt.error}`,
          );
          break;
      }
    });
  }

  checkForUpdate(): void {
    if (!this.swUpdate.isEnabled) {
      console.info("Service worker updates are disabled.");
      return;
    }

    setInterval(
      async () => {
        try {
          if (this.isNewVersionAvailable == false) {
            this.isNewVersionAvailable = await this.swUpdate.checkForUpdate();
          }
        } catch (error) {
          console.info("Failed to check for updates:", error);
        }
        console.info(
          this.isNewVersionAvailable
            ? "A new version is available."
            : "Already on the latest version.",
        );
      },
      1 * 30 * 1000,
    );
  }

  applyUpdate(): void {
    // Reload the page to update to the latest version after the new version is activated
    this.swUpdate
      .activateUpdate()
      .then(() => document.location.reload())
      .catch((error) => console.error("Failed to apply updates:", error));
  }
}
